<div class="loading" *ngIf="loading"><mat-spinner diameter="28"></mat-spinner></div>
<div class="notice bad" *ngIf="error">{{ error }}</div>

<ng-container *ngIf="setup as s">
  <div class="notice warn" *ngIf="s.brainIsStub">
    <span class="pill stub">Stub brain</span> No Claude key here: Sharon answers from the deterministic QA stub.
  </div>

  <section class="panel start">
    <h3>Start a simulated member</h3>
    <div class="row">
      <select class="input grow" [(ngModel)]="personaId" aria-label="Persona">
        <option *ngFor="let p of s.personas" [value]="p.id">{{ p.label }}</option>
      </select>
      <select class="input" [(ngModel)]="cause" aria-label="Cause">
        <option *ngFor="let c of s.causes" [value]="c.id">{{ c.label }}</option>
      </select>
      <select class="input" [(ngModel)]="mode" aria-label="Mode">
        <option value="auto">Auto</option>
        <option value="assisted">Assisted</option>
      </select>
      <button mat-flat-button color="primary" (click)="start()" [disabled]="busy || !personaId">
        {{ busy === 'start' ? 'Starting…' : 'Start' }}
      </button>
    </div>
    <div class="sims" *ngIf="sims.length">
      <span class="label">Earlier runs</span>
      <button type="button" *ngFor="let c of sims" [class.on]="c.id === simId" (click)="reopen(c.id)">
        #{{ c.id }} {{ c.memberName }} · {{ c.cause }} · {{ modeLabels[c.mode] }}
      </button>
    </div>
  </section>

  <div class="sim" *ngIf="simId">
    <div class="left">
      <app-conversation-view [conversationId]="simId" [view]="simView"
        (viewChange)="onViewChange($event)"></app-conversation-view>

      <section class="panel member">
        <h3>You are the member</h3>
        <textarea class="input" rows="2" [(ngModel)]="memberText" [disabled]="!!busy"
          placeholder="What the member writes" aria-label="Member message"
          (keydown.meta.enter)="sendMember()" (keydown.control.enter)="sendMember()"></textarea>
        <div class="row">
          <button mat-flat-button color="primary" (click)="sendMember()" [disabled]="!!busy || !memberText.trim()">
            {{ busy === 'member' ? 'Sharon is thinking…' : 'Send as member' }}
          </button>
          <button mat-stroked-button (click)="advance()" [disabled]="!!busy">Advance clock</button>
          <button mat-stroked-button (click)="reset()" [disabled]="!!busy">Reset</button>
          <button mat-stroked-button class="danger" (click)="remove()" [disabled]="!!busy">Delete</button>
        </div>
        <h3>Scripts</h3>
        <div class="scripts">
          <button type="button" class="script" *ngFor="let sc of s.scripts" (click)="playScript(sc)"
            [disabled]="!!busy || progress(sc) >= sc.messages.length" [title]="sc.expect">
            <span class="title">{{ sc.label }}</span>
            <span class="muted">{{ progress(sc) }}/{{ sc.messages.length }}
              <ng-container *ngIf="progress(sc) < sc.messages.length">· next: {{ sc.messages[progress(sc)] }}</ng-container>
            </span>
          </button>
        </div>
      </section>
    </div>

    <aside class="panel diag">
      <h3>Last step <span class="pill stub" *ngIf="step?.brainIsStub">Stub brain</span></h3>
      <p class="empty" *ngIf="!step">Send a member message, play a script or advance the clock to see what Sharon decides.</p>
      <ng-container *ngIf="step as st">
        <dl class="kv">
          <dt>Action</dt>
          <dd>{{ st.outcome?.action ?? 'none (Sharon did not act)' }}</dd>
          <ng-container *ngIf="st.outcome as o">
            <dt>Model</dt><dd>{{ o.brain.model }}{{ o.brain.stub ? ' (stub)' : '' }}</dd>
            <ng-container *ngIf="o.brain.error"><dt>Brain error</dt><dd class="bad">{{ o.brain.error }}</dd></ng-container>
            <ng-container *ngIf="o.frozen">
              <dt>Froze</dt><dd class="bad">{{ freezeLabel(o.frozen.reason) }}</dd>
              <ng-container *ngIf="o.frozen.detail"><dt>Why</dt><dd class="text">{{ o.frozen.detail }}</dd></ng-container>
            </ng-container>
            <dt>Checks</dt>
            <dd [class.bad]="o.checks && !o.checks.ok">{{ o.checks ? (o.checks.ok ? 'passed' : 'failed') : 'not run' }}</dd>
            <dt>Paced send</dt><dd>{{ o.pacedSendAt ? (o.pacedSendAt | date: 'EEE d MMM, HH:mm') : '—' }}</dd>
            <dt>Intel</dt><dd>{{ o.intelRecorded }} recorded · {{ o.intelDropped }} dropped</dd>
            <ng-container *ngIf="o.note"><dt>Note</dt><dd class="text">{{ o.note }}</dd></ng-container>
          </ng-container>
          <dt>Would act at</dt><dd>{{ st.pacing.wouldActAt ? (st.pacing.wouldActAt | date: 'EEE d MMM, HH:mm') : '—' }}</dd>
          <dt>Fast path</dt>
          <dd [class.bad]="st.fastPath">
            {{ st.fastPath ? ((st.fastPath.botSuspicion ? 'bot suspicion ' : '') + (st.fastPath.stopRequest ? 'stop request' : '')) : 'no signal' }}
          </dd>
        </dl>
        <p class="meta">{{ st.pacing.note }}</p>
        <ul class="problems" *ngIf="st.outcome?.checks?.problems?.length">
          <li *ngFor="let p of st.outcome?.checks?.problems">{{ p }}</li>
        </ul>
        <h3>Brain output</h3>
        <pre class="json">{{ st.outcome?.brain?.output | json }}</pre>
      </ng-container>
    </aside>
  </div>
</ng-container>
